export const readAccessToken = () => {
  try {
    const raw = localStorage.getItem("accessToken");
    if (!raw) return "";
    const parsed = JSON.parse(raw);
    return typeof parsed === "string" ? parsed : "";
  } catch {
    return "";
  }
};

/** Append Sanctum token so the backend can serve live vs 15-minute delayed Trade Flash. */
export const tradeFlashSocketUrl = (baseUrl) => {
  if (!baseUrl) return baseUrl;
  const token = readAccessToken();
  if (!token) return baseUrl;
  const sep = baseUrl.includes("?") ? "&" : "?";
  return `${baseUrl}${sep}token=${encodeURIComponent(token)}`;
};
